export const Config = {
  AuthApiUrl: process.env.GATSBY_AUTH_API_URL || process.env.AUTH_API_URL || 'https://api.az.hypercite.net',
  BaseApiUrl: process.env.GATSBY_BASE_API_URL || process.env.BASE_API_URL || 'https://api.az.hypercite.net',
  RecaptchaKey: process.env.RECAPTCHA_KEY || '6Ldx7qsZAAAAAHIiezZkMYoSOwKWqmh2zTbEm0gE',
  AccessTokenKey: process.env.GATSBY_ACCESS_TOKEN_KEY || process.env.ACCESS_TOKEN_KEY || 'az-hypercite.access_token',
  RefreshTokenKey: process.env.GATSBY_REFRESH_TOKEN_KEY || process.env.REFRESH_TOKEN_KEY || 'az-hypercite.refresh_token',
  StripePublishableKey: process.env.STRIPE_PUBLIC_KEY || '',
};
